import { StrictLocalizeFunction } from "../localization";
import { intlDate } from "../localization/date-fns/intlDate";

import { getStoreOpeningDateValues } from "./STORE_OPENING_DATE_VALUES";

export const STORE_OPENING_DATE_ALREADY_OPEN_VALUE = -1;

export const getStoreOpeningDateOptions = (
  strictLocalize: StrictLocalizeFunction,
  showAlreadyOpen?: boolean,
  startDate?: Date
) => {
  const monthValues = getStoreOpeningDateValues(startDate);

  const dateOptions = [
    {
      label: strictLocalize({
        defaultMessage: "This month",
        description: {
          text: "Option in a dropdown menu for selecting a store opening date for this month.",
        },
      }),
      value: monthValues[0],
    },
    {
      label: strictLocalize({
        defaultMessage: "Next month",
        description: {
          text: "Option in a dropdown menu for selecting a store opening date for next month.",
        },
      }),
      value: monthValues[1],
    },
    ...monthValues.slice(2, 6).map((monthValue) => ({
      label: intlDate(monthValue, "MMMM yyyy"),
      value: monthValue,
    })),
    {
      label: monthValues[5]
        ? strictLocalize(
            {
              defaultMessage: "After {formattedDate}",
              description: {
                text: "Option in a dropdown menu for selecting a store opening date after a certain month.",
              },
            },
            {
              formattedDate: intlDate(monthValues[5], "MMMM yyyy"),
            }
          )
        : strictLocalize({
            defaultMessage: "Other",
            description: {
              text: "Option in a dropdown menu for store opening date. If no dates apply, then the retailer can select other",
            },
          }),
      value: monthValues[6],
    },
  ];

  if (showAlreadyOpen) {
    dateOptions.splice(0, 0, {
      label: strictLocalize({ defaultMessage: "My store is already open" }),
      value: STORE_OPENING_DATE_ALREADY_OPEN_VALUE,
    });
  }

  return dateOptions;
};

export const STORE_OPENING_DATE_OPTIONS = (
  strictLocalize: StrictLocalizeFunction
) => getStoreOpeningDateOptions(strictLocalize);
export const STORE_OPENING_DATE_OPTIONS_WITH_ALREADY_OPEN = (
  strictLocalize: StrictLocalizeFunction
) => getStoreOpeningDateOptions(strictLocalize, true);
